import { Component,OnInit } from '@angular/core';
import * as Highcharts from 'highcharts';
import { Router, ActivatedRoute, Params } from '@angular/router';
import {RestapiService} from '../restapi.service';
import { Chart } from 'angular-highcharts';

declare var require: any;
let Boost = require('highcharts/modules/boost');
let noData = require('highcharts/modules/no-data-to-display');
let More = require('highcharts/highcharts-more');

Boost(Highcharts);
noData(Highcharts);
More(Highcharts);
noData(Highcharts);

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css',
              './shards-dashboards.1.1.0.min.css',
              './extras.1.1.0.min.css'],
  //encapsulation: ViewEncapsulation.None,
})
export class DashboardComponent implements OnInit {
	
	viewSection    =	"Quarter";
  viewSubSelect  =  "policy";
	monthYear		   =	"";
	monthInsurer	 =	"";
	monthLob       =	"";
  quarterYear    =  "";
  quarterQuarter =  "";
  quarterLob     =  "";
  quarterLoc     =  "";
  gdpi           =  0;
  pc             =  0;
  amtClaimRep    =  0;
  nocRep         =  0;
  amtClaimPaid   =  0;
  nocPaid        =  0;
	mnthYrArr		=	[];
	mnthInsArr		=	[];
	mnthnLobArr		=	[];
  qYrArr        = [];
  qQtrArr       = [];
  qLobArr       = [];
  qLocArr       = [];
	monthCatArray =	["M01 - Apr","M02 - May","M03 - Jun","M04 - Jul","M05 - Aug","M06 - Sep","M07 - Oct","M08 - Nov","M09 - Dec","M10 - Jan","M11 - Feb","M12 - Mar"];
	respObject: any;
	mgObj: any;
   highcharts = Highcharts;
   mGraphOptions = {   
      chart: {
         type: "line"
      },
      title: {
         text: ""
      },
      subtitle: {
         text: ""
      },
      credits: {
      	enabled: false
      },
      lang: {
        thousandsSep: ","
      },
      legend: {
        align: "left" as "left",
        verticalAlign: "top" as "top",
        x: 0,
        y: 0
       },
      xAxis:{
         categories:this.monthCatArray
      },
      yAxis: {          
         title:{
            text:"Rs. in Lacs"
         } 
      },
      plotOptions: {
         series: {
            dataLabels: {
               enabled: false
            },
            marker: {
                enabled: false
            }
         }
      },
      tooltip: {
         shared: true,
         crosshairs: true
      },
      series: []
   };
   mGPolOptions = {   
      chart: {
         type: "line"
      },
      title: {
         text: ""
      },
      subtitle: {
         text: ""
      },
      lang: {
        thousandsSep: ","
      },
      credits: {
      	enabled: false
      },
      legend: {
        align: "left" as "left",
        verticalAlign: "top" as "top",
        x: 0,
        y: 0
       },
      xAxis:{
         categories:this.monthCatArray
      },
      yAxis: {          
         title:{
            text:""
         } 
      },
      plotOptions: {
         series: {
            dataLabels: {
               enabled: false
            },
            marker: {
                enabled: false
            }
         }
      },
      tooltip: {
         shared: true,
         crosshairs: true
      },
      series: []
   };
   chart = new Chart(this.mGraphOptions);
   mgpchart = new Chart(this.mGPolOptions);
   statPolOptions = {   
      chart: {
         type: "column"
      },
      title: {
         text: ""
      },
      subtitle: {
         text: ""
      },
      credits: {
        enabled: false
      },
      lang: {
        thousandsSep: ","
      },
      colors:['#1E4A7B','#F5D33F','#FF08FA'],
      xAxis:{
         categories:this.genRand(),
         title:{text:"States"}
      },
      yAxis: {          
         title:{
            text:""
         } 
      },
      plotOptions: {
        column: {
            stacking: 'normal' as 'normal',
            dataLabels: {
                enabled: false
            }
        }
    },
      tooltip: {
        // headerFormat: '<b>Location: {point.x}</b><br/>',
        //pointFormat: 'Type of Insurer: {series.name}<br/>No.of Claims: {point.y}'
      },
      series: []
   };
   statClaimOptions = {   
      chart: {
         type: "column"
      },
      title: {
         text: ""
      },
      subtitle: {
         text: ""
      },
      credits: {
        enabled: false
      },
      lang: {
        thousandsSep: ","
      },
      colors:['#1E4A7B','#F5D33F','#FF08FA'],
      xAxis:{
         categories:this.genRand(),
         title:{text:"States"}
      },
      yAxis: {          
         title:{
            text:""
         } 
      },
      plotOptions: {
        column: {
            stacking: 'normal' as 'normal',
            dataLabels: {
                enabled: false
            }
        }
    },
      tooltip: {
        // headerFormat: '<b>Location: {point.x}</b><br/>',
        //pointFormat: 'Type of Insurer: {series.name}<br/>No.of Claims: {point.y}'
      },
      series: []
   };
   statPolPremchart = new Chart();
   statClaimchart = new Chart();
   chClaimChart = new Chart();
   chPolPremChart = new Chart();
   chClaimOptions = {   
      chart : {
      	 type: 'pie',
         plotBorderWidth: null,
         plotShadow: false
      },
      title : {
         text: ''   
      },
      credits: {
        enabled: false
      },
      tooltip : {
         pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
      },
      legend: {
      	title: {
            text: '<strong>Types of Channel</strong>',
            style: {
                /*fontStyle: 'italic'*/
            }
        },
      	layout: 'vertical' as 'vertical',
        align: 'left' as 'left',
        x: 0,
        verticalAlign: 'top' as 'top',
        y: 0,
        floating: true,
        backgroundColor:
            Highcharts.defaultOptions.legend.backgroundColor || 'white',
        //borderColor: '#CCC',
        /*borderWidth: 1,*/
        shadow: false,
        padding:5,
        itemMarginTop:15

       },
       plotOptions : {
         pie: {
            shadow: false,
            center: ['70%', '50%'] as ['70%', '50%'],
            size:'60%',
            innerSize: '60%',
            showInLegend: true            
         }
      },
      series : []
   };
   chPolOptions = {   
      chart : {
         type: 'pie',
         plotBorderWidth: null,
         plotShadow: false
      },
      title : {
         text: ''   
      },
      credits: {
        enabled: false
      },
      tooltip : {
         pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
      },
      legend: {
        title: {
            text: '<strong>Types of Channel</strong>',
            style: {
                /*fontStyle: 'italic'*/
            }
        },
        layout: 'vertical' as 'vertical',
        align: 'left' as 'left',
        x: 0,
        verticalAlign: 'top' as 'top',
        y: 0,
        floating: true,
        backgroundColor:
            Highcharts.defaultOptions.legend.backgroundColor || 'white',
        //borderColor: '#CCC',
        /*borderWidth: 1,*/
        shadow: false,
        padding:5,
        itemMarginTop:15

       },
       plotOptions : {
         pie: {
            shadow: false,
            center: ['70%', '50%'] as ['70%', '50%'],
            size:'60%',
            innerSize: '60%',
            showInLegend: true            
         }
      },
      series : []
   };
    respConfig: any;
    configVal="";
    constructor(private router: Router,private route: ActivatedRoute, private _rest: RestapiService) { }
    ngOnInit(){
      this.viewSection	=	"Quarter";
      this.viewSubSelect  =  "policy";
		  const sData = {};
		  this._rest.getFilterData(sData).subscribe((res) => {
  		  this.respObject = res;
  		  if(this.respObject.error==0){
  		  	//console.log(this.respObject.resp.monthYear.length);
  		  		for(var i=0;i< this.respObject.resp.monthYear.length;i++){
  		  			//console.log(this.respObject.resp.monthYear[i].year);
  		  			this.mnthYrArr.push(this.respObject.resp.monthYear[i]);
  		  			this.monthYear = this.respObject.resp.monthYear[i].year;
  		  		}
  		  		for(var i=0;i<this.respObject.resp.monthInsurer.length;i++){
  		  			this.mnthInsArr.push(this.respObject.resp.monthInsurer[i]);
  		  		}
            this.monthInsurer = "All";
  		  		for(var i=0;i<this.respObject.resp.monthLob.length;i++){
  		  			this.mnthnLobArr.push(this.respObject.resp.monthLob[i]);
  		  		}
            this.monthLob = "All";
            if(this.respObject.resp.quarterYear.length>0){
              for(var i=0;i<this.respObject.resp.quarterYear.length;i++){
                this.qYrArr.push(this.respObject.resp.quarterYear[i].year);
                this.quarterYear = this.respObject.resp.quarterYear[i].year;
              }
            }
            if(this.respObject.resp.quarterQuarter.length>0){
              for(var i=0;i<this.respObject.resp.quarterQuarter.length;i++){
                this.qQtrArr.push(this.respObject.resp.quarterQuarter[i].quarter);
                this.quarterQuarter = this.respObject.resp.quarterQuarter[i].quarter;
              }
            }
            if(this.respObject.resp.quarterLob.length>0){
              for(var i=0;i<this.respObject.resp.quarterLob.length;i++){
                this.qLobArr.push(this.respObject.resp.quarterLob[i].lob);
              }
            }
            this.quarterLob = "All";
            if(this.respObject.resp.quarterLoc.length>0){
              for(var i=0;i<this.respObject.resp.quarterLoc.length;i++){
                this.qLocArr.push(this.respObject.resp.quarterLoc[i].state);
              }
            }  
            this.quarterLoc = "All";      
  		   	  this.genMonthPremNPol();
            this.genQuarterPremPol();
  		    } else {
            console.log(res);
  		    }
		  });
      const dataConfRes = {"configType":"PD_NOTE"};
      this.configVal = "";
      this._rest.getSettingsData(dataConfRes).subscribe((res) => {
            this.respConfig = res;
          if(this.respConfig.error==0){ 
            if(this.respConfig.resp.length>0){
              this.configVal=this.respConfig.resp[0].KeyValue;
            }             
          }   
      });
   	}
   	chnageView(viewSection){
   		this.viewSection	=	viewSection;
      if(viewSection="Quarter"){
        this.genQuarterPremPol();
      } else {
        this.genMonthPremNPol();
      }
   	}
    chnageSubView(viewSubSection){
      //alert('hi');
      this.viewSubSelect  = viewSubSection;
      this.genQuarterPremPol();
    }
   getRndInteger(min, max) {
  	return Math.floor(Math.random() * (max - min) ) + min;
   }
   genRand(){
   	var randValues = [];
   	for(var i=0;i<36;i++){
   		//randValues.push(this.getRndInteger(1,10000));
      randValues.push(0);
   	}
   	return randValues;
   }


   genQuarterPremPol(){
    const graphData = {"year":this.quarterYear,"quarter":this.quarterQuarter,"lob":this.quarterLob,"locatoion":this.quarterLoc,"status":"1" };
    var statPolGSeries =[];
    statPolGSeries.push({"name":"General Insurer","data": [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]});
    statPolGSeries.push({"name":"Specialized Insurer","data": [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]});
    statPolGSeries.push({"name":"Stand Health Insurer","data": [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]});
         
    var statPremGSeries = [];
    statPremGSeries.push({"name":"General Insurer","data": [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]});
    statPremGSeries.push({"name":"Specialized Insurer","data": [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]});
    statPremGSeries.push({"name":"Stand Health Insurer","data": [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]});

    var statClaimPolGSeries =[];
    statClaimPolGSeries.push({"name":"General Insurer","data": [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]});
    statClaimPolGSeries.push({"name":"Specialized Insurer","data": [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]});
    statClaimPolGSeries.push({"name":"Stand Health Insurer","data": [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]});
         
    var statClaimPremGSeries = [];
    statClaimPremGSeries.push({"name":"General Insurer","data": [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]});
    statClaimPremGSeries.push({"name":"Specialized Insurer","data": [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]});
    statClaimPremGSeries.push({"name":"Stand Health Insurer","data": [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]});

    this._rest.getPdStatPolPrem(graphData).subscribe((res) => {
      this.mgObj   = res;
      console.log(res);
      
      if(this.mgObj.error==0){
        if(this.mgObj.resp.length>0){
          for(var i=0;i<this.qLocArr.length;i++){
            for(var j=0;j<this.mgObj.resp.length;j++){
              if(this.mgObj.resp[j].locOrChannel==this.qLocArr[i]){
                if(this.mgObj.resp[j].industryType=="General"){
                  statPolGSeries[0].data[i]=this.mgObj.resp[j].polOrClaim;
                  statPremGSeries[0].data[i]=this.mgObj.resp[j].premOrAmt;
                } else if(this.mgObj.resp[j].industryType=="Standalone Health"){
                  statPolGSeries[2].data[i]=this.mgObj.resp[j].polOrClaim;
                  statPremGSeries[2].data[i]=this.mgObj.resp[j].premOrAmt;
                } else if(this.mgObj.resp[j].industryType=="Specialized"){
                  statPolGSeries[1].data[i]=this.mgObj.resp[j].polOrClaim;
                  statPremGSeries[1].data[i]=this.mgObj.resp[j].premOrAmt;                
                }
              }
            }
          }
        }
      }
      if(this.viewSubSelect=="policy"){
        this.statPolOptions["xAxis"]["categories"] = this.qLocArr;

        this.statPolOptions["series"]=statPolGSeries;
        this.statPolOptions["yAxis"]["title"]= {"text":"Number of Policies"}
        
        //console.log(this.statPolOptions["series"]);
        this.statPolOptions["tooltip"] = {"headerFormat":"<b>Location: {point.x}</b><br/>","pointFormat":"Type of Insurer: {series.name}<br/>No.of Policies: {point.y:.0f}"};
        console.log(JSON.stringify(statPolGSeries));

      } else {
        this.statPolOptions["xAxis"]["categories"] = this.qLocArr;
        this.statPolOptions["series"]=statPremGSeries;
         this.statPolOptions["yAxis"]["title"]= {"text":"Rs. in Lacs."}
        this.statPolOptions["tooltip"] = {"headerFormat":"<b>Location: {point.x}</b><br/>","pointFormat":"Type of Insurer: {series.name}<br/>Total Premium: Rs. {point.y:.2f} (in Lacs.)"};
        console.log(JSON.stringify(statPremGSeries));
      }
      console.log(JSON.stringify(this.statPolOptions));
      this.statPolPremchart = new Chart(this.statPolOptions);
    });
    this._rest.getPdStatClaim(graphData).subscribe((res) => {
      this.mgObj   = res;
      //console.log(res);
      
      if(this.mgObj.error==0){
        if(this.mgObj.resp.length>0){
          for(var i=0;i<this.qLocArr.length;i++){
            for(var j=0;j<this.mgObj.resp.length;j++){
              if(this.mgObj.resp[j].locOrChannel==this.qLocArr[i]){
                if(this.mgObj.resp[j].industryType=="General"){
                  statClaimPolGSeries[0].data[i]=this.mgObj.resp[j].polOrClaim;
                  statClaimPremGSeries[0].data[i]=this.mgObj.resp[j].premOrAmt;
                } else if(this.mgObj.resp[j].industryType=="Standalone Health"){
                  statClaimPolGSeries[2].data[i]=this.mgObj.resp[j].polOrClaim;
                  statClaimPremGSeries[2].data[i]=this.mgObj.resp[j].premOrAmt;
                } else if(this.mgObj.resp[j].industryType=="Specialized"){
                  statClaimPolGSeries[1].data[i]=this.mgObj.resp[j].polOrClaim;
                  statClaimPremGSeries[1].data[i]=this.mgObj.resp[j].premOrAmt;                
                }
              }
            }
          }
        }
      }
      if(this.viewSubSelect=="policy"){
        this.statClaimOptions["xAxis"]["categories"] = this.qLocArr;
        this.statClaimOptions["series"]=statClaimPolGSeries;
        //console.log(this.statPolOptions["series"]);
        this.statClaimOptions["tooltip"] = {"headerFormat":"<b>Location: {point.x}</b><br/>","pointFormat":"Type of Insurer: {series.name}<br/>No.of Claims: {point.y:.0f}"};
        this.statClaimOptions["yAxis"]["title"]= {"text":"Number of Claims"}
      } else {
        this.statClaimOptions["xAxis"]["categories"] = this.qLocArr;
        this.statClaimOptions["series"]=statClaimPremGSeries;
        this.statClaimOptions["tooltip"] = {"headerFormat":"<b>Location: {point.x}</b><br/>","pointFormat":"Type of Insurer: {series.name}<br/>Total Amount: Rs. {point.y:.2f} (in Lacs.)"};
        this.statClaimOptions["yAxis"]["title"]= {"text":"Rs. in Lacs."}
      }
      this.statClaimchart = new Chart(this.statClaimOptions);
    });
    const chClaimSeries = {"type":"pie","name":"Channelwise Paid Claims","data":[]};
    //chClaimSeries.push({"type":"pie","name":"Channelwise Paid Claims","data":[{"name":"No Data","y":100}]});
    this._rest.getPdChClaim(graphData).subscribe((res) => {
      this.mgObj   = res;
      //console.log(res);
      
      if(this.mgObj.error==0){
        if(this.mgObj.resp.length>0){
          //chClaimSeries[0]["data"].pop();
          for(var i=0;i<this.mgObj.resp.length;i++){
            if(this.viewSubSelect=="policy"){
              chClaimSeries["data"].push({"name":this.mgObj.resp[i].locOrChannel,"y":this.mgObj.resp[i].polOrClaim});
            } else {
              chClaimSeries["data"].push({"name":this.mgObj.resp[i].locOrChannel,"y":this.mgObj.resp[i].premOrAmt});
            }
          }
        }
      }
      
      /*if(this.chClaimOptions["series"].length>0){
        this.chClaimOptions["series"].pop();
      }*/
      this.chClaimOptions["series"][0]=chClaimSeries;
      console.log(this.chClaimOptions);
      this.chClaimChart = new Chart(this.chClaimOptions);
    });
    const chPolSeries = {"type":"pie","name":"Channelwise Premium & Policies","data":[]};
    this._rest.getPdChPolPrem(graphData).subscribe((res) => {
      this.mgObj   = res;      
      if(this.mgObj.error==0){
        if(this.mgObj.resp.length>0){
          for(var i=0;i<this.mgObj.resp.length;i++){
            if(this.viewSubSelect=="policy"){
              chPolSeries["data"].push({"name":this.mgObj.resp[i].locOrChannel,"y":this.mgObj.resp[i].polOrClaim});
            } else {
              chPolSeries["data"].push({"name":this.mgObj.resp[i].locOrChannel,"y":this.mgObj.resp[i].premOrAmt});
            }
          }
        }
      }
      
      /*if(this.chPolOptions["series"].length>0){
        this.chPolOptions["series"].pop();
      }*/
      this.chPolOptions["series"][0]=chPolSeries;
      console.log(this.chPolOptions);
      this.chPolPremChart = new Chart(this.chPolOptions);
    });
    this.gdpi           =  0;
    this.pc             =  0;
    this.amtClaimRep    =  0;
    this.nocRep         =  0;
    this.amtClaimPaid   =  0;
    this.nocPaid        =  0;
    this._rest.getAllPdTabData(graphData).subscribe((res) => {
      this.mgObj   = res;
     // console.log(res);      
      if(this.mgObj.error==0){
      //  console.log(this.mgObj.resp);
        this.gdpi           =  (this.mgObj.resp.gdpi!="")?this.mgObj.resp.gdpi.toLocaleString('en-IN'):0;
        this.pc             =  (this.mgObj.resp.pc!="")?this.mgObj.resp.pc.toLocaleString('en-IN'):0;
        this.amtClaimRep    =  (this.mgObj.resp.amtClaimRep!="")?this.mgObj.resp.amtClaimRep.toLocaleString('en-IN'):0;
        this.nocRep         =  (this.mgObj.resp.nocRep!="")?this.mgObj.resp.nocRep.toLocaleString('en-IN'):0;
        this.amtClaimPaid   =  (this.mgObj.resp.amtClaimPaid!="")?this.mgObj.resp.amtClaimPaid.toLocaleString('en-IN'):0;
        this.nocPaid        =  (this.mgObj.resp.nocPaid!="")?this.mgObj.resp.nocPaid.toLocaleString('en-IN'):0;
      }
    });
   }
   genMonthPremNPol(){
   	var gSeries	=	[]
   	var gPSeries	=	[]
   	var splitYr	=	this.monthYear.split("-");
   	var currYr	=	this.monthYear;
   	var prevyr	=	"";
   	if(splitYr.length==2){
   		prevyr	=	(parseInt(splitYr[0])-1)+"-"+(parseInt(splitYr[1])-1);
   	}
   	gSeries.push({"name":currYr,"data":[0,0,0,0,0,0,0,0,0,0,0,0]});
   	gSeries.push({"name":prevyr,"data":[0,0,0,0,0,0,0,0,0,0,0,0],"dashStyle": 'shortdash'});
   	gPSeries.push({"name":currYr,"data":[0,0,0,0,0,0,0,0,0,0,0,0]});
   	gPSeries.push({"name":prevyr,"data":[0,0,0,0,0,0,0,0,0,0,0,0],"dashStyle": 'shortdash'});
   	
   	
   	const graphData = {"year":this.monthYear,"insurer":this.monthInsurer,"lob":this.monthLob };
   	this._rest.getPremNPolForMonth(graphData).subscribe((res) => {
   		this.mgObj = res;
   		//console.log(res);
   		if(this.mgObj.error==0){
   			if(this.mgObj.resp.length>0){
   				for(var i=0;i<this.monthCatArray.length;i++){
   					for(var j=0;j<this.mgObj.resp.length;j++){   						
   						if(this.monthCatArray[i]==this.mgObj.resp[j].month){						
   							gSeries[0]["data"][i] = this.mgObj.resp[j].premium;   							
   							gSeries[1]["data"][i] = this.mgObj.resp[j].prevPremium;
   							gPSeries[0]["data"][i] = this.mgObj.resp[j].policies;   							
   							gPSeries[1]["data"][i] = this.mgObj.resp[j].prevPolicies;
   						}
   					}
   				}
   			} 
   		} 
   		this.mGraphOptions["series"] = gSeries;
   		this.mGPolOptions["series"] = gPSeries;
   		this.chart= new Chart(this.mGraphOptions);
   		this.mgpchart= new Chart(this.mGPolOptions);
   	});
   }

   goscrolldown(){
      window.location.hash = "lastsection";
   }
}
